import { render, staticRenderFns } from "./RequestsBase.vue?vue&type=template&id=cd1fa674&"
import script from "./RequestsBase.vue?vue&type=script&lang=js&"
export * from "./RequestsBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports